import { ConnectorIds } from '@/common/constants';
import ApprovalIcon from '@/images/approval.svg';
import ConfigureIcon from '@/images/configure.svg';
import DocsIcon from '@/images/docs-mark-dark.svg';
import F4SFIcon from '@/images/forms4sf-mark-dark.svg';
import FormsIcon from '@/images/forms-mark-dark.svg';
import SignIcon from '@/images/sign-mark-dark.svg';
import UtilityIcon from '@/images/utility-cog.svg';

export function getConnectorIcon(connectorId?: ConnectorIds) {
  return connectorId && ConnectorIconMap[connectorId];
}

type ConnectorIconMapType = {
  [key in ConnectorIds]: string;
};

export const ConnectorIconMap: ConnectorIconMapType = {
  [ConnectorIds.Documents]: DocsIcon,
  [ConnectorIds.FormstackForm]: FormsIcon,
  [ConnectorIds.Sign]: SignIcon,
  [ConnectorIds.F4SF]: F4SFIcon,
  [ConnectorIds.StepLogic]: ConfigureIcon,
  [ConnectorIds.Approval]: ApprovalIcon,
  [ConnectorIds.API]: UtilityIcon,
};

export const ConnectorColorMap: { [key in ConnectorIds]?: string } = {
  [ConnectorIds.Documents]: '#F0F5FA',
  [ConnectorIds.FormstackForm]: '#F7EDE8',
  [ConnectorIds.Sign]: '#FAF2FA',
  [ConnectorIds.F4SF]: '#F5DECC',
  [ConnectorIds.StepLogic]: '#F7EDE8',
};

const INCONNECTABLE_CONNECTORS = [ConnectorIds.StepLogic, ConnectorIds.Approval, ConnectorIds.API];

export const isConnectable = (connectorId: ConnectorIds) =>
  !INCONNECTABLE_CONNECTORS.includes(connectorId);
